module.exports = __webpack_public_path__ + "static/media/urbangoo27.eb298219.webp";